module.exports = __webpack_public_path__ + "static/img/2018ltyj3.1329111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/2018ltyj3.jpg
// module id = OqzM
// module chunks = 0